import produce, { Draft } from "immer";
// Assuming LoadingStatus type/enum path is correct relative to this file
import { LoadingStatus } from "../../status";
import { SiloGroupAT } from './actionTypes';
import {SiloGroupActions} from "./actionCreators";

// Define the state shape for the Silo Group configuration slice
interface SiloGroupState {
    groupTypes:any,
    configData: any; // Array of device configuration objects
    error: any;
    status: LoadingStatus;
}

const initialSiloGroupState: SiloGroupState = {
    groupTypes:null,
    configData: null,
    error: null,
    status: LoadingStatus.NEVER,
};

// Use the produce function for immutability
export const siloGroupReducer = produce((draft: Draft<SiloGroupState>, action: SiloGroupActions) => {

    switch (action.type) {
        // --- Fetch and Save Request ---
        case SiloGroupAT.FETCH_SILO_CONFIG_REQUEST:
        case SiloGroupAT.SAVE_SILO_CONFIG_REQUEST:

            draft.status = LoadingStatus.LOADING;
            draft.error = null;

            break;

        // --- Fetch Success ---
        case SiloGroupAT.FETCH_SILO_CONFIG_SUCCESS:
            // CRITICAL: Store the fetched configuration array
            draft.configData = action.payload.configData;
            draft.status = LoadingStatus.LOADED;

            draft.error = null;
            break;

        case SiloGroupAT.FETCH_SILO_GROUP_TYPE_SUCCESS:
            // CRITICAL: Store the fetched configuration array
            draft.groupTypes = action.payload.groupTypes;
            draft.status = LoadingStatus.LOADED;

            draft.error = null;
            break;
        // --- Save Success ---
        case SiloGroupAT.SAVE_SILO_CONFIG_SUCCESS:
            // When saving succeeds, the component state should already hold the newest config,
            // so we just confirm the success status.
            draft.status = LoadingStatus.SUCCESS;
            draft.error = null;
            break;

        // --- Failure ---
        case SiloGroupAT.FETCH_SILO_CONFIG_FAILURE:
        case SiloGroupAT.FETCH_SILO_GROUP_TYPE_FAILURE:
        case SiloGroupAT.SAVE_SILO_CONFIG_FAILURE:

            draft.status = LoadingStatus.ERROR;
            draft.error = action.payload.error;
            break;

        default:
            break;
    }
}, initialSiloGroupState);